import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { BaseScaffoldComponent } from '../base-scaffold/base-scaffold.component';
import { RenderedService } from '../../rendered.service';
import { IntegrationService } from '@services/integration.service';
import { UserService } from '@services/user.service';
import { Router } from '@angular/router';

@Component({
    selector: 'scaffold-integration-status',
    templateUrl: './integration-status.component.html',
    styleUrls: ['./integration-status.component.scss'],
    standalone: false
})
export class IntegrationStatusComponent
  extends BaseScaffoldComponent
  implements OnInit
{
  constructor(
    public renderedService: RenderedService,
    public cdr: ChangeDetectorRef,
    private integrationService: IntegrationService,
    private userService: UserService,
    private router: Router
  ) {
    super(cdr, renderedService);
  }
  integrations: any = [];
  roleData: any;

  ngOnInit(): void {
    this.userService.getRoleDetails().subscribe(data => {
      this.roleData = data;
    });
    this.integrationService
      .getIntegrationsNetworkCall$()
      .subscribe(integrations => {
        //this.integrationsService.getIntegrations(null,null,true).subscribe((integrations) => {
        integrations = integrations || [];
        this.integrations = integrations.map
          ? integrations.map(integration => ({
              ...integration,
              ...integration.json_data,
            }))
          : [];
        console.log(this.integrations);
        this.update();
      });
  }

  handleBannerEditClick($event) {
    if (this.roleData?.manage_integrations) {
      this.router.navigate(['admin/integrations/edit/' + $event.id]);
    }
  }
}
